import Inflection from "inflection";

export function parameterize(string) {
  return Inflection.dasherize(string.toLowerCase());
}
